export default [
  // Solo 2 - 2:38

  {m:80, t: 8, pos: 4},

  {m:81, t: 1, pos: 3, hold: 3},
  // {m:81, t: 2, pos: 3},
  // {m:81, t: 3, pos: 2},
  {m:81, t: 4, pos: 2, hold: 4},
  // {m:81, t: 5, pos: 5},
  // {m:81, t: 6, pos: 3},
  // {m:81, t: 7, pos: 4},
  {m:81, t: 8, pos: 4},

  {m:82, t: 1, pos: 3, hold: 3},
  // {m:82, t: 2, pos: 3},
  // {m:82, t: 3, pos: 2},
  {m:82, t: 4, pos: 2, hold: 4},
  // {m:82, t: 5, pos: 5},
  // {m:82, t: 6, pos: 3},
  // {m:82, t: 7, pos: 4},
  {m:82, t: 8, pos: 4},

  {m:83, t: 1, pos: 3, hold: 3},
  // {m:83, t: 2, pos: 3},
  // {m:83, t: 3, pos: 2},
  {m:83, t: 4, pos: 1, hold: 4},
  // {m:83, t: 5, pos: 5},
  // {m:83, t: 6, pos: 3},
  // {m:83, t: 7, pos: 4},
  {m:83, t: 8, pos: 4},

  {m:84, t: 1, pos: 3, hold: 3},
  // {m:84, t: 2, pos: 3},
  // {m:84, t: 3, pos: 2},
  {m:84, t: 4, pos: 1, hold: 4},
  // {m:84, t: 5, pos: 5},
  // {m:84, t: 6, pos: 3},
  // {m:84, t: 7, pos: 4},
  {m:84, t: 8, pos: 4},

  {m:85, t: 1, pos: 3, hold: 7},
  // {m:85, t: 2, pos: 3},
  // {m:85, t: 3, pos: 2},
  // {m:85, t: 4, pos: 1},
  // {m:85, t: 5, pos: 5},
  // {m:85, t: 6, pos: 3},
  // {m:85, t: 7, pos: 4},
  {m:85, t: 8, pos: 4},

  {m:86, t: 1, pos: 3, hold: 4},
  // {m:86, t: 2, pos: 3},
  // {m:86, t: 3, pos: 2},
  // {m:86, t: 4, pos: 1},
  {m:86, t: 5, pos: 2},
  {m:86, t: 5.5, pos: 3},
  {m:86, t: 6, pos: 2},
  {m:86, t: 7, pos: 1},
  {m:86, t: 8, pos: 3, hold: 7},


  // {m:87, t: 1, pos: 3},
  // {m:87, t: 2, pos: 3},
  // {m:87, t: 3, pos: 2},
  // {m:87, t: 4, pos: 1},
  // {m:87, t: 5, pos: 5},
  {m:87, t: 6, pos: 5},
  {m:87, t: 7, pos: 2},
  {m:87, t: 7.5, pos: 3, hold: 1.5},
  // {m:87, t: 8, pos: 3},

  {m:88, t: 1, pos: 2, hold: 7},
  // {m:88, t: 2, pos: 3},
  // {m:88, t: 3, pos: 2},
  // {m:88, t: 4, pos: 1},
  // {m:88, t: 5, pos: 5},
  // {m:88, t: 6, pos: 5},
  // {m:88, t: 7, pos: 2},
  {m:88, t: 8, pos: 4},

  {m:89, t: 1, pos: 3, hold: 3},
  // {m:89, t: 2, pos: 3},
  // {m:89, t: 3, pos: 2},
  {m:89, t: 4, pos: 2, hold: 4},
  // {m:89, t: 5, pos: 5},
  // {m:89, t: 6, pos: 5},
  // {m:89, t: 7, pos: 2},
  {m:89, t: 8, pos: 4},

  {m:90, t: 1, pos: 3, hold: 3},
  // {m:90, t: 2, pos: 3},
  // {m:90, t: 3, pos: 2},
  {m:90, t: 3.5, pos: 3},
  {m:90, t: 4.5, pos: 4, hold: 1.5},
  {m:90, t: 6, pos: 5, hold: 1.25},
  {m:90, t: 7.25, pos: 5, hold: 1.75},
  // {m:90, t: 8, pos: 4},

  {m:91, t: 1, pos: 4, hold: 3},
  // {m:91, t: 2, pos: 3},
  // {m:91, t: 3, pos: 2},
  {m:91, t: 4.5, pos: 4},
  {m:91, t: 5, pos: 5, hold: 3},
  // {m:91, t: 6, pos: 5},
  // {m:91, t: 7, pos: 2},
  {m:91, t: 8, pos: 8},

  {m:92, t: 1, pos: 5, hold: 1.5},
  // {m:92, t: 2, pos: 3},
  {m:92, t: 2.5, pos: 4},
  // {m:92, t: 3, pos: 2},
  {m:92, t: 4, pos: 4, hold: 2},
  // {m:92, t: 5, pos: 5},
  {m:92, t: 6, pos: 3, hold: 2},
  // {m:92, t: 7, pos: 2},
  {m:92, t: 8, pos: 3},

  {m:93, t: 1, pos: 2, hold: 2},
  // {m:93, t: 2, pos: 3},
  {m:93, t: 3, pos: 5},
  {m:93, t: 4, pos: 4, hold: 3},
  // {m:93, t: 5, pos: 5},
  // {m:93, t: 6, pos: 5},
  {m:93, t: 7, pos: 2},
  {m:93, t: 7.5, pos: 3},
  {m:93, t: 8, pos: 2},
  {m:93, t: 8.5, pos: 1},

  {m:94, t: 1, pos: 2},
  {m:94, t: 1.5, pos: 3, hold: 1.5},
  // {m:94, t: 2, pos: 3},
  {m:94, t: 3, pos: 4},
  {m:94, t: 4, pos: 4},
  {m:94, t: 4.5, pos: 5, hold: 2.5},
  // {m:94, t: 5, pos: 5},
  // {m:94, t: 6, pos: 5},
  {m:94, t: 7, pos: 4},
  {m:94, t: 8, pos: 3},
  {m:94, t: 8.5, pos: 4, hold: 1.5},

  {m:95, t: 1, pos: 4, hold: 15}, {m:95, t: 1, pos: 5, hold: 15},

  //m:96 holding
];



//////////////////
// WEBPACK FOOTER
// ./lib/songs/song_solo_2.js
// module id = 15
// module chunks = 0